// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import {
  Select,
  Option,
  DatePicker,
  InputNumber,
  Form,
  FormItem,
  Page,
  Dropdown,
  DropdownMenu,
  Menu,
  Input,
  MenuItem,
  Icon,
  DropdownItem,
  Slider,
  Message,
  Modal,
  CheckboxGroup,
  Checkbox,
  Radio,
  RadioGroup,
  ButtonGroup,
  TimePicker,
  Cascader,
  Circle,
  Tree,
  Spin,
  Carousel,
  Tooltip,
  CarouselItem,
  Alert,
  Steps,
  Step,
  Breadcrumb,
  BreadcrumbItem,
  Timeline,
  TimelineItem,
  // AutoComplete
  Button,
  Table,
  Tabs,
  TabPane,
  Poptip
} from 'iview';
// import 'iview/dist/styles/iview.css';

import './style/theme.less';
import AutoComplete from '@/components/modal/autoComplete/index.js';

import store from './vuex/index';
import axios from './config/axios';
import filters from './config/filtes';
import global from './tool/global';
import directive from './directive';
import imagePreview from '@/components/modal/imagePreview/index'
import myMessage from '@/components/myMessage'

Vue.component('i-select', Select);
Vue.component('i-option', Option);
Vue.component('i-input', Input);
Vue.component('Icon', Icon);
Vue.component('DatePicker', DatePicker);
Vue.component('InputNumber', InputNumber);
Vue.component('i-form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Page', Page);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Slider', Slider);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('ButtonGroup', ButtonGroup);
Vue.component('Time-picker', TimePicker);
Vue.component('Timeline', Timeline);
Vue.component('Timeline-item', TimelineItem);
Vue.component('Cascader', Cascader);
Vue.component('i-circle', Circle);
Vue.component('Tree', Tree);
Vue.component('Spin', Spin);
Vue.component('Tooltip', Tooltip);
Vue.component('Carousel', Carousel);
Vue.component('Carousel-item', CarouselItem);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Breadcrumb-item', BreadcrumbItem);
Vue.component('Alert', Alert);
Vue.component('Steps', Steps);
Vue.component('Step', Step);
Vue.component('AutoComplete', AutoComplete);
Vue.component('i-button', Button);
Vue.component('i-poptip', Poptip);
Vue.component('Table', Table);
Vue.component('Tabs',Tabs)
Vue.component('TabPane',TabPane)
  

Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
Vue.prototype.$preview = imagePreview
Vue.prototype.$myMessage = myMessage

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
/* 全局变量，方法 */
Object.keys(global).forEach(key => {
  Vue.prototype[key] = global[key];
});
/* 全局指令 */
Object.keys(directive).forEach(key => {
  Vue.directive(key, directive[key]);
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js